module.exports = __webpack_public_path__ + "24e004ab/img/settings-icon.121d9519.svg";